import SpinnerClimbing from './spinner-climbing.vue';
import SpinnerJumping from './spinner-jumping.vue';
import SpinnerBallGridPulse from './spinner-ball-grid-pulse.vue';
import SpinnerBallBeat from './spinner-ball-beat.vue';
import SpinnerCircle from './spinner-circle.vue';
export default {
  install(app) {
    const register = (name, component) => {
      const resolved = component?.default ?? component;
      if (resolved && (typeof resolved === 'object' || typeof resolved === 'function')) {
        app.component(name, resolved);
      }
    };

    register('SpinnerClimbing', SpinnerClimbing);
    register('SpinnerJumping', SpinnerJumping);
    register('SpinnerBallGridPulse', SpinnerBallGridPulse);
    register('SpinnerBallBeat', SpinnerBallBeat);
    register('SpinnerCircle', SpinnerCircle);
  },
};
